import { render } from "./expressManage.vue?vue&type=template&id=0ca13540&scoped=true"
import script from "./expressManage.vue?vue&type=script&lang=js"
export * from "./expressManage.vue?vue&type=script&lang=js"

import "./expressManage.vue?vue&type=style&index=0&id=0ca13540&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ca13540"

export default script